export const VN_DEBUGGER_ENABLED = 'VN_DEBUGGER_ENABLED'
export const VN_SIMULATED_DISCONNECTION = 'VN_SIMULATED_DISCONNECTION'
export const VN_CARD_READER_ERROR = 'VN_CARD_READER_ERROR'
export const VN_DEBUGGER_PASSTHROUGH_ENABLED = 'VN_DEBUGGER_PASSTHROUGH_ENABLED'
export const VN_DEBUGGER_PASSTHROUGH_MESSAGE = 'VN_DEBUGGER_PASSTHROUGH_MESSAGE'
